'use client';

import { c as _c } from "react/compiler-runtime";
import { ArrowRight } from '@byway/icons';
import NumberFlow from '@number-flow/react';
import { useLocale, useTranslations } from 'next-intl';
import { Button } from '~/components/Button';
import { TripPriceSkeleton } from '~/components/TripOverview/booking/TripPriceSkeleton';
import styles from './StickyFooter.module.css';
import type { StickyFooterProps } from './StickyFooter.types';
export function StickyFooter(t0) {
  const $ = _c(37);
  const {
    dateRange,
    travellerCount,
    price,
    currency: t1,
    priceLabel: t2,
    PriceRow,
    ctaLabel: t3,
    onCtaClick,
    isCtaDisabled: t4,
    onPriceClick,
    className
  } = t0;
  const currency = t1 === undefined ? "GBP" : t1;
  const priceLabel = t2 === undefined ? "person" : t2;
  const ctaLabel = t3 === undefined ? "Continue" : t3;
  const isCtaDisabled = t4 === undefined ? false : t4;
  const t = useTranslations("journey");
  const locale = useLocale();
  let t5;
  if ($[0] !== t || $[1] !== travellerCount) {
    t5 = t("sticky_footer_traveller_count", {
      count: travellerCount
    });
    $[0] = t;
    $[1] = travellerCount;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const travellerText = t5;
  const showPriceSkeleton = price === undefined;
  const summaryText = dateRange ? `${dateRange} • ${travellerText}` : travellerText;
  let t6;
  if ($[3] !== currency || $[4] !== locale || $[5] !== price || $[6] !== showPriceSkeleton) {
    t6 = <span className={styles.priceValue}>{showPriceSkeleton ? <TripPriceSkeleton /> : <NumberFlow value={price} locales={locale} format={{
        style: "currency",
        currency,
        minimumFractionDigits: 0,
        maximumFractionDigits: 0,
        useGrouping: true,
        currencyDisplay: "symbol"
      }} />}</span>;
    $[3] = currency;
    $[4] = locale;
    $[5] = price;
    $[6] = showPriceSkeleton;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  const priceValue = t6;
  const t7 = `${styles.aside} ${className ?? ""}`;
  let t8;
  if ($[8] !== t7) {
    t8 = t7.trim();
    $[8] = t7;
    $[9] = t8;
  } else {
    t8 = $[9];
  }
  let t9;
  if ($[10] !== t) {
    t9 = t("sticky_footer_aria_label");
    $[10] = t;
    $[11] = t9;
  } else {
    t9 = $[11];
  }
  let t10;
  if ($[12] !== PriceRow || $[13] !== priceValue) {
    t10 = PriceRow ? <PriceRow>{priceValue}</PriceRow> : priceValue;
    $[12] = PriceRow;
    $[13] = priceValue;
    $[14] = t10;
  } else {
    t10 = $[14];
  }
  let t11;
  if ($[15] !== priceLabel) {
    t11 = <span className={styles.priceSuffix}> {priceLabel}</span>;
    $[15] = priceLabel;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== onPriceClick || $[18] !== showPriceSkeleton || $[19] !== t10 || $[20] !== t11) {
    t12 = <button type="button" className={styles.priceButton} onClick={onPriceClick} disabled={showPriceSkeleton}>{t10}{t11}</button>;
    $[17] = onPriceClick;
    $[18] = showPriceSkeleton;
    $[19] = t10;
    $[20] = t11;
    $[21] = t12;
  } else {
    t12 = $[21];
  }
  let t13;
  if ($[22] !== summaryText) {
    t13 = <p className={styles.summary}>{summaryText}</p>;
    $[22] = summaryText;
    $[23] = t13;
  } else {
    t13 = $[23];
  }
  let t14;
  if ($[24] !== t12 || $[25] !== t13) {
    t14 = <div className={styles.info}>{t12}{t13}</div>;
    $[24] = t12;
    $[25] = t13;
    $[26] = t14;
  } else {
    t14 = $[26];
  }
  let t15;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <ArrowRight decorative={true} isInline={true} size="small" />;
    $[27] = t15;
  } else {
    t15 = $[27];
  }
  let t16;
  if ($[28] !== ctaLabel || $[29] !== isCtaDisabled || $[30] !== onCtaClick) {
    t16 = <Button variant="primary" size="fullWidth" onPress={onCtaClick} isDisabled={isCtaDisabled}>{ctaLabel} {t15}</Button>;
    $[28] = ctaLabel;
    $[29] = isCtaDisabled;
    $[30] = onCtaClick;
    $[31] = t16;
  } else {
    t16 = $[31];
  }
  let t17;
  if ($[32] !== t14 || $[33] !== t16 || $[34] !== t8 || $[35] !== t9) {
    t17 = <aside className={t8} aria-label={t9} data-test-id="StickyFooter">{t14}{t16}</aside>;
    $[32] = t14;
    $[33] = t16;
    $[34] = t8;
    $[35] = t9;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
}